import axios from 'axios'
import store from '../store'
import { getToken } from '@/utils/auth'

const service = axios.create({
  baseURL: 'api', //document.location.origin + process.env.BASE_API, // api的base_url
  timeout: 60000, // 请求超时时间设置为1分钟
})
const service1 = axios.create({
  baseURL: 'threed', //document.location.origin + process.env.BASE_API, // api的base_url
  timeout: 60000, // 请求超时时间设置为1分钟
})
var serviceUrl = ''
if(process.env.HOST == "http://guansj.cc/"){
  serviceUrl = process.env.BASE_API
}else{
  serviceUrl = document.location.origin + process.env.BASE_API
}
const serviceApi = serviceUrl
const host = process.env.HOST
// request拦截器
service.interceptors.request.use(config => {
  //console.log(getToken())
  if (getToken()) {
    config.headers.Authorization = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  } 
  //console.log(config)
  return config
}, error => {
  // Do something with request error
  //console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    if (response.config.url.indexOf('token') >= 0) {
      if (response.status === 200) {
        return response.data
      } else {
        return Promise.reject(new Error('登录时(request.js文件未处理的状态码):' + response.status))
      }
    } else {
      return response.data
    }
  },
  error => {
    if (typeof error.response === 'undefined') {
      error.message = '服务器无响应-500'
    } else {
      if (error.response.status === 400) {
        error.message = error.response.data.error_description
      } else {
      }
    }
    return Promise.reject(error)
  }
)
//export default service
export default {service, service1, host, serviceApi}


// WEBPACK FOOTER //
// ./src/utils/request.js